import styled from 'styled-components';
import { QuestionCircleOutlined } from '@ant-design/icons';

export const StyledQuestionCircleOutlined = styled(QuestionCircleOutlined)`
  margin-right: 0.5rem;
`;
